import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { MatDialog } from '@angular/material/dialog';
import { ReconnectDialogComponent } from './reconnect-dialog/reconnect-dialog.component';
import { environment } from 'src/environments/environment';

const GSIS_PROVIDER = 'task-management-gsis';

@Injectable({ providedIn: 'root' })
export class KeycloakAuthService {
  constructor(
    private keycloak: KeycloakService,
    private dialog: MatDialog
  ) { }

  login(options?: any) {
    return this.keycloak.login(options);
  }

  register(options?: any) {
    return this.keycloak.register(options);
  }

  async logout(redirectUri?: string, skipDialog = false): Promise<void> {
    const token = this.getParsedToken();
    const isGsis = token?.identity_provider === GSIS_PROVIDER;

    if (!skipDialog && isGsis) {
      // Dialog πρώτα → μετά cleanup → μετά logout
      const dialogRef = this.dialog.open(ReconnectDialogComponent, {
        disableClose: true,
        panelClass: 'reconnect-dialog-panel',
        data: { redirectUri },
      });
      dialogRef.afterClosed().subscribe(async confirmed => {
        if (confirmed) {
          await this.triggerGsisSessionCleanup();
          this.keycloak.logout(redirectUri ?? undefined);
        }
      });
      return;
    }

    // Manual logout (skipDialog=true) ή non-GSIS: cleanup → logout
    if (isGsis) {
      await this.triggerGsisSessionCleanup();
    }
    return this.keycloak.logout(redirectUri ?? undefined);
  }

  private async triggerGsisSessionCleanup(): Promise<void> {
    const { url, clientId, keycloakRedirectUrl } = environment.taxisnet;
    if (!url || !clientId) return;
    const redirectUrl = `${url}/${clientId}/?url=${keycloakRedirectUrl}`;
    const popup = window.open(redirectUrl, 'taxisnetLogout', 'width=600,height=400,scrollbars=yes');
    await new Promise<void>(resolve => setTimeout(resolve, 150));
    try {
      if (popup && !popup.closed) popup.close();
    } catch { }
  }

  isLoggedIn() {
    return this.keycloak.isLoggedIn();
  }

  getToken(): Promise<string> {
    return this.keycloak.getToken();
  }

  getParsedToken(): any {
    return this.keycloak.getKeycloakInstance().tokenParsed || {};
  }

  getTokenSync(): string | undefined {
    return this.keycloak.getKeycloakInstance().token;
  }

  updateToken(minValidity: number = 30): Promise<boolean> {
    return this.keycloak.getKeycloakInstance().updateToken(minValidity);
  }

  getClaimsForCheckUser() {
    const token = this.getParsedToken();
    return {
      keycloakId: token.sub || null,
      email: token.email || null,
      lastName: token.family_name || null,
      firstName: token.given_name || null,
      gemiNumber: token.gemiNumber || null,
      afm: token.afm || null,
      companyId: token.companyIds?.[0] || null,
      username: token.preferred_username || null,
    };
  }
}
